module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('cell', {
    staticClass: "cell-height",
    attrs: {
      "value-align": "left",
      "is-link": !_vm.jsPassanger
    },
    nativeOn: {
      "click": function($event) {
        return _vm.choose($event)
      }
    }
  }, [_c('img', {
    staticClass: "cell-lable-right",
    attrs: {
      "slot": "icon",
      "width": "16px",
      "height": "16px",
      "src": require("../../assets/img/user.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "cell-fontSize",
    staticStyle: {
      "display": "inline-block",
      "width": "80%",
      "padding-top": ".5rem"
    },
    attrs: {
      "slot": "value"
    },
    slot: "value"
  }, [_c('span', {
    staticStyle: {
      "white-space": "nowrap",
      "display": "inline-block",
      "overflow": "hidden",
      "text-overflow": "ellipsis",
      "width": "8.3rem"
    },
    style: (_vm.yz(_vm.jsPassanger))
  }, [_vm._v(_vm._s(_vm.jsPassanger ? _vm.jsPassanger : _vm.noMsg))])]), _vm._v(" "), (_vm.jsPassanger) ? _c('div', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "slot": "child"
    },
    slot: "child"
  }, [_c('x-button', {
    staticStyle: {
      "background": "#0d87e4",
      "padding": "1px 8px",
      "white-space": "nowrap"
    },
    attrs: {
      "type": "primary",
      "mini": ""
    }
  }, [_vm._v("更换联系人")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e7f2976"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/choosePerson.vue
// module id = 412
// module chunks = 1